import { render, staticRenderFns } from "./helpPayForDetail.vue?vue&type=template&id=0130d9a8&"
import script from "./helpPayForDetail.vue?vue&type=script&lang=js&"
export * from "./helpPayForDetail.vue?vue&type=script&lang=js&"
import style0 from "./helpPayForDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports